import {defineStore} from "pinia";
import {computed, ref} from "vue";

export const useDonationStore = defineStore('donationStore', () => {
	const predefinedDonations = ref([]);
	const selectedDonation = ref(null);

	const customDonationValue = ref(null);

	const userSupportFees = ref(true)
	const userDeclineGift = ref(true);
	const medallionFlag = ref(null);

	const billingInfo = ref(null);

	const currentStepIndex = ref(0);

	const donationFrequencies = ref([]);
	const selectedDonationFrequency = ref(null);

	const organizationSlug = ref(null);

	const isDonationCompleted = ref(false);
	const error = ref(null);

	const isCustomDonation = computed(() => {
		if(!selectedDonation.value) {
			return false;
		}
		return selectedDonation.value.isCustomDonation;
	});

	const withMedallionGift = computed(() => {
		if(!medallionFlag.value || medallionFlag.value === 0) {
			return false;
		}

		return true;
	});

	const amountToBeDonated = computed(() => {
		if(!selectedDonation.value) {
			return 0;
		}

		if(isCustomDonation.value || selectedDonationFrequency.value.id === 1) {
			return selectedDonation.value.amount;
		}

		//todo: revert the if below
		if(!Object.hasOwn(selectedDonation.value, 'amount_recurring')) {
			return selectedDonation.value.amount;
		}

		return selectedDonation.value.amount_recurring;
	})

	const activeLevelDonationIndex = computed(() => {
		if(!selectedDonation.value) {
			return 1;
		}
		const index = predefinedDonations.value.findIndex((donation) => {
			return donation.id === selectedDonation.value.id;
		})
		return index + 1;
	});

	function nextStep() {
		currentStepIndex.value++;
	}


	function previousStep() {
		currentStepIndex.value--;
	}

	function resetStore() {
		selectedDonation.value = predefinedDonations.value[0];
		userSupportFees.value = true;
		userDeclineGift.value = true;
		billingInfo.value = null;
		currentStepIndex.value = 0;
		selectedDonationFrequency.value = donationFrequencies.value[1];
		error.value = null;
		isDonationCompleted.value = false;
		customDonationValue.value = null;
	}

	return {
		predefinedDonations,
		selectedDonation,
		customDonationValue,
		userSupportFees,
		userDeclineGift,
		billingInfo,
		donationFrequencies,
		selectedDonationFrequency,
		organizationSlug,
		currentStepIndex,
		isDonationCompleted,
		error,
		isCustomDonation,
		amountToBeDonated,
		activeLevelDonationIndex,
		nextStep,
		previousStep,
		resetStore,
		medallionFlag,
		withMedallionGift
	}
})